import { Renderer } from "ogl";
import { isWebGLUsable } from "./is-webgl-usable";

type OglRendererOptions = ConstructorParameters<typeof Renderer>[0];

/**
 * OGL assigns `gl.renderer` in its constructor. When the browser cannot
 * create a WebGL context, `gl` is null and that assignment throws
 * "Cannot set properties of null (setting 'renderer')". Preflight first so
 * OGL never logs "unable to create webgl context" as a console error.
 */
export function tryCreateOglRenderer(
	options?: OglRendererOptions,
): InstanceType<typeof Renderer> | null {
	if (!isWebGLUsable()) {
		return null;
	}
	try {
		const renderer = new Renderer(options);
		if (!renderer.gl) {
			return null;
		}
		return renderer;
	} catch {
		return null;
	}
}
